
import RepeateMusic from "../../../assets/duotone/RepeateMusic.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function RepeateMusicIcon({ className, dataTestid = "RepeateMusicIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <RepeateMusic data-testid={dataTestid} className={classes} {...rest} />
  );
}
